import { render, staticRenderFns } from "./EditExhibition.vue?vue&type=template&id=46d5113e&"
import script from "./EditExhibition.vue?vue&type=script&lang=js&"
export * from "./EditExhibition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports